
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFccSmsCredentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fccSmsIid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fccSmsUid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fccSmsApiKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fccSmsSender"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fccSmsUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fccSmsIid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fccSmsIid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fccSmsUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fccSmsUid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fccSmsApiKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fccSmsApiKey"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fccSmsSender"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fccSmsSender"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fccSmsUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fccSmsUrl"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smsGatewayCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fccSmsIid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fccSmsUid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fccSmsApiKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fccSmsSender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fccSmsUrl"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":451}};
    doc.loc.source = {"body":"mutation updateFccSmsCredentials(\n  $fccSmsIid: String\n  $fccSmsUid: String\n  $fccSmsApiKey: String\n  $fccSmsSender: String\n  $fccSmsUrl: String\n) {\n  updateConfigurations(\n    input: {\n      fccSmsIid: $fccSmsIid\n      fccSmsUid: $fccSmsUid\n      fccSmsApiKey: $fccSmsApiKey\n      fccSmsSender: $fccSmsSender\n      fccSmsUrl: $fccSmsUrl\n    }\n  ) {\n    smsGatewayCode\n    fccSmsIid\n    fccSmsUid\n    fccSmsApiKey\n    fccSmsSender\n    fccSmsUrl\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["updateFccSmsCredentials"] = oneQuery(doc, "updateFccSmsCredentials");
        
